import { Vue, Component } from "vue-property-decorator"
import { OrderStatus } from "@/types/enum/OrderEnum"
import { IOrderStatusForRequestOrderList } from "@/types/interface/IOrderDto"

@Component
export default class OrderBaseMixins extends Vue {
  Processing: OrderStatus[] = [
    OrderStatus.WaitingForAcceptance,
    OrderStatus.Processing,
    OrderStatus.Ready,
    OrderStatus.Delivering
  ]
  Incoming: OrderStatus[] = [OrderStatus.WaitingForAcceptance]
  Preparing: OrderStatus[] = [OrderStatus.Processing]
  Ready: OrderStatus[] = [OrderStatus.Ready]

  Delivering: OrderStatus[] = [OrderStatus.Delivering]

  Completed: OrderStatus[] = [
    OrderStatus.Completed,
    OrderStatus.CancelRejected,
    OrderStatus.Cancelled
  ]

  Refund: OrderStatus[] = [
    OrderStatus.Refunding,
    OrderStatus.Refunded,
    OrderStatus.CancelRequested
  ]

  Rejected: OrderStatus[] = [OrderStatus.Rejected]
}
